/** A short code is exactly 5 characters after '+' is removed, all digits.

91929 and +91929 match. (91929), 91 929 and a 10-digit customer number do not.
*/

export function fiveDigitCode(phone) {
  if (phone == null) return ''
  const raw = String(phone).replace(/\+/g, '')
  return /^\d{5}$/.test(raw) ? raw : ''
}

/** True when a visible SMS toast already shows this short code and this text. */
export function isSameFiveDigitBurst(popups, phone, preview) {
  const code = fiveDigitCode(phone)
  if (!code) return false
  const text = preview || ''
  return (popups || []).some((p) =>
    p && p.type === 'sms' && fiveDigitCode(p.phone) === code && (p.preview || '') === text
  )
}
